import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbSidebarService } from '@nebular/theme';

@Component({
  selector: 'ngx-mobile-footer',
  styleUrls: ['./mobile-footer.component.scss'],
  template: `
    <footer class="mobile-footer-nav">
      <a routerLink="/pages/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
        <nb-icon icon="grid-outline"></nb-icon>
        <span>Home</span>
      </a>

      <a routerLink="/pages/order-details/ongoing-orders" routerLinkActive="active">
        <nb-icon icon="shopping-cart-outline"></nb-icon>
        <span>Orders</span>
      </a>

      <a routerLink="/pages/complaints" routerLinkActive="active">
        <nb-icon icon="alert-circle-outline"></nb-icon>
        <span>Complaints</span>
      </a>

      <a routerLink="/pages/team" routerLinkActive="active">
        <nb-icon icon="people-outline"></nb-icon>
        <span>Team</span>
      </a>

      <a class="menu-btn" (click)="toggleMenu()">
        <nb-icon icon="menu-2-outline"></nb-icon>
        <span>Menu</span>
      </a>
    </footer>
  `,
})
export class MobileFooterComponent {
  constructor(
    private router: Router,
    private sidebarService: NbSidebarService,
  ) {}

  toggleMenu(): void {
    this.sidebarService.toggle(true, 'menu-sidebar');
  }
}
